import { APP_ACTION_TYPES } from '../../core/constants/actionTypes';

export const cntrlAppInit = payload => ({
  type: APP_ACTION_TYPES.APP_INIT,
  payload,
});

